import React from "react";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter
} from "@/components/ui/dialog";
import { cn } from "@/utils/utils";

interface Props {
  trigger?: JSX.Element;
  title?: JSX.Element;
  description?: string;
  descriptionClassname?: string;
  content: JSX.Element | null;
  footer?: JSX.Element;
  open?: boolean;
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  headerClassname?: string;
  contentClassname?: string;
  footerClassname?: string;
  hideDivider?: boolean;
  showCloseButton?: boolean;
  "data-test"?: string;
  contentContainerClassname?: string;
  onOpenAutoFocus?: (event: Event) => void;
}

const Modal: React.FC<Props> = ({
  trigger,
  title,
  description,
  descriptionClassname,
  content,
  footer,
  open,
  setIsOpen,
  headerClassname,
  contentClassname,
  footerClassname,
  hideDivider,
  showCloseButton = true,
  "data-test": dataTest,
  contentContainerClassname,
  onOpenAutoFocus
}) => {
  const testId = dataTest || "modal";
  return (
    <Dialog open={open} onOpenChange={(open) => setIsOpen && setIsOpen(open)}>
      {trigger && <DialogTrigger>{trigger}</DialogTrigger>}
      <DialogContent
        className={contentClassname}
        showCloseButton={showCloseButton}
        data-test={`${testId}-content`}
        onOpenAutoFocus={onOpenAutoFocus}
      >
        <DialogHeader
          className={headerClassname}
          data-test={`${testId}-header`}
        >
          <DialogTitle data-test={`${testId}-title`}>{title}</DialogTitle>
          <DialogDescription className={descriptionClassname}>
            {description}
          </DialogDescription>
        </DialogHeader>
        <div
          className={cn(
            hideDivider ? "" : " border-b-[0.5px] border-border-border1",
            contentContainerClassname
          )}
          data-test={`${testId}-body`}
        >
          {content}
        </div>
        {footer && (
          <DialogFooter
            data-test={`${testId}-footer`}
            className={footerClassname}
          >
            {footer}
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
};
export default Modal;
